/**
 * src/components/UpgradeBanner.js
 * Reusable inline banner for gated features.
 */

import React from 'react';

export default function UpgradeBanner({ feature, currentPlan, message }) {
  const text = message || `This feature requires an upgraded plan. Current plan: ${currentPlan || 'Free'}.`;
  return (
    <div style={{
      padding: '10px 14px',
      background: 'var(--accent-subtle)',
      border: '1px solid var(--accent)',
      borderRadius: '6px',
      fontSize: '13px',
      color: 'var(--text-primary)',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    }}>
      <span style={{ fontSize: '16px' }}>&#x1f512;</span>
      <span>{text}</span>
    </div>
  );
}
